<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>
            As part of signing up for the Explore Enterprise course with the
            Prince’s Trust, we’d like to know more about why you’d like to start
            a business and the stage you’re at with your business idea.
        </p>
        <InputRadioGroup
            name="describe_business"
            :required="isRequired('describe_business')"
            :error="form.errors.get('describe_business')"
            v-model="form.describe_business"
            :options="getField('describe_business').options"
            :form="form"
            @textarea-updated="form[$event.field] = $event.value"
            @input="form.errors.clear('describe_business')"
        >
            <template v-slot:question>
                {{ getField("describe_business").question }}
            </template>
        </InputRadioGroup>

        <InputText
            v-if="form.describe_business == 'I want to be my own boss but no idea yet' ||
                form.describe_business == 'I\'ve got an idea, but not sure of steps' ||
                form.describe_business == 'Past the idea stage, actively planning'"
            name="business_reason_text"
            :required="isRequired('business_reason_text')"
            :error="form.errors.get('business_reason_text')"
            v-model="form.business_reason_text"
            :is-multiline="true"
        >
            <template v-slot:question>
                {{ getField("business_reason_text").question }}
            </template>
            <template v-slot:description>
                {{ getField("business_reason_text").description }}
            </template>
        </InputText>

        <InputText
            v-if="form.describe_business == 'Already started, take it to next level' ||
            form.describe_business == 'Trading < 3 years, support for growth' ||
            form.describe_business == '>3 years, successfully running business'"
            name="business_reason_2_text"
            :required="isRequired('business_reason_2_text')"
            :error="form.errors.get('business_reason_2_text')"
            v-model="form.business_reason_2_text"
            :is-multiline="true"
        >
            <template v-slot:question>
                {{ getField("business_reason_2_text").question }}
            </template>
            <template v-slot:description>
                {{ getField("business_reason_2_text").description }}
            </template>
        </InputText>

        <InputText
            name="about_business_idea_text"
            :required="isRequired('about_business_idea_text')"
            :error="form.errors.get('about_business_idea_text')"
            v-model="form.about_business_idea_text"
            :is-multiline="true"
        >
            <template v-slot:question>
                {{ getField("about_business_idea_text").question }}
            </template>
            <template v-slot:description>
                {{ getField("about_business_idea_text").description }}
            </template>
        </InputText>

        <InputRadioGroup
            name="cowork_with_others"
            :required="isRequired('cowork_with_others')"
            :error="form.errors.get('cowork_with_others')"
            v-model="form.cowork_with_others"
            :options="getField('cowork_with_others').options"
            @input="form.errors.clear('cowork_with_others')"
        >
            <template v-slot:question>
                {{ getField("cowork_with_others").question }}
            </template>
        </InputRadioGroup>
    </div>
</template>

<script>
import InputText from "../Form/InputText";
import InputRadioGroup from "../Form/InputRadioGroup";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepExploreEnterprise",
    components: {
        InputText,
        InputRadioGroup,
    },
    methods: {
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
    },
    data: function () {
        return {
            form: new Form({
                describe_business: null,
                about_business_idea_text: null,
                cowork_with_others: null,
                business_reason_text: null,
                business_reason_2_text: null,
            }, this.formData),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
    },
};
</script>